import { Button } from 'antd';
import React, { useContext } from 'react'
import styled from 'styled-components';
import { ObservationsContext } from '../../ObservationsContextContainer'

const TableHeader = styled.th`
    text-align: left;
`;

const EllipsisFriendlyTD = styled.td`
    max-width: 0;
    text-overflow: ellipsis;
    overflow: hidden;
`;

const StyledLink = styled.a`
    width: 50%;
    overflow: hidden;
    text-overflow: ellipsis;
`;

export default function HiddenClashesList() {
    const observationsContext = useContext(ObservationsContext);

    const onRemoveClicked = (id: string) => {
        observationsContext.observationsStateDispatch({ type: 'removeClashToForget', id });
    };

    return (
        <>
            <table>
                <tbody>
                    <tr>
                        <TableHeader style={{"width": "60%"}}>Havaintotunnus</TableHeader>
                        <TableHeader style={{"width": "30%"}}>MKI-saap.päivä</TableHeader>
                        <TableHeader style={{"width": "10%"}}></TableHeader>
                    </tr>
                    {
                        observationsContext.observationsState.clashesToForget?.filter(hc => hc && hc.id).map(clashToForget => {
                            return <tr key={clashToForget.id}>
                                <EllipsisFriendlyTD><StyledLink target="blank" title={clashToForget.unitId} href={clashToForget.unitId}>{clashToForget.unitId.replace("httasdasdp://tun.fi/", "")}</StyledLink></EllipsisFriendlyTD>
                                <td><span>{new Date(clashToForget.declarationArrivalDate).toLocaleDateString("fi-FI")}</span></td>
                                <td><Button onClick={() => onRemoveClicked(clashToForget.id)}>X</Button></td>
                            </tr>
                        })
                    }
                </tbody>
            </table>
        </>
    )
}